export interface IAddressLink {
  id: number
  name: string
  type: string
  address: string
  storageData?: {
    uniqId?: string
    objectSchemeIdentifier?: string
    primary?: string
    secondary?: null
    icon?: null
    parentObjectUniqId?: null | string
    fieldValue?: string
  }
}

export enum InternalLabels {
  INBOX = 'inbox',
  SENT = 'sent',
  DRAFT = 'draft',
  TRASH = 'trash',
  ARCHIVE = 'archive',
  SPAM = 'spam',
}

export enum PrivateValues {
  PRIVATE = 'private',
  PUBLIC = 'public',
}

export interface IAttachment {
  contentType: string
  downloadLink: string
  emailId: number
  filename: string
  identifier: string
  size: number
  uuid: string
}

export interface IEmail {
  id: number
  identifier: string
  status: string
  syncAt: string
  createdAt: string
  userId?: number
  info: {
    id: number
    subject: string
    snippet: string
    body: string
    mimeType: string
  }
  attachments: IAttachment[]
  addressLinks: IAddressLink[]
  userData?: {
    id: number
    info?: {
      firstName?: string
      lastName?: string
      avatar?: string
    }
  }
}

export interface IMailAccount {
  id: number
  identifier: string
  status: string
  type: PrivateValues
  userId: number
}

export interface ICustomLabel {
  code: string
  color: null | string
  icon: null | string
  isHidden?: boolean
  isInternal?: boolean
  label?: string
}

export interface IThread {
  id: string
  identifier: string
  subject: string
  lastEmail: IEmail
  account: {
    id: number
    userId: number
    identifier: string
    title: string
    type: string
    status: string
    lastSyncAt: string
    createdAt: string
  }
  labels: ICustomLabel[]
  lastMessageAt: string
  shared: boolean
  emails: IEmail[]
}
